module.exports = "<div class=\"page-inner\">\n\t<p>\n\t  page-not-found works!\n\t</p>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /home/kalinin/angular2/PRACTICE/feedback/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = 1